module.exports = __webpack_public_path__ + "static/13-caf51d0c5f00a6bf9949f0c0ec0df731.jpg";